/*
 * Standard fonts to be used with CSS font property
 */
export const HEADING_01 = `600 26px Segoe UI`;
export const HEADING_02 = `600 23px Segoe UI`;
export const HEADING_03 = `600 20px Segoe UI`;
export const SUBTITLE = `600 14px Segoe UI`;
export const BODY = `400 14px Segoe UI`;
export const MINI_HEADER = `400 12px Segoe UI`;
